import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faGithub,
  faLinkedin,
  faInstagram,
  faFacebookMessenger,
} from "@fortawesome/free-brands-svg-icons";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export const Contactme = () => {
  return (
    <>
      <div className="max-w-7xl mx-auto pb-10 px-4 xs:pt-5 sm:pt-0 sm:px-6 lg:px-8 grid md:grid-cols-2 lg:grid-cols-2 md:gap-x-8 lg:gap-x-8 ">
        <div>
          <h2 className="text-3xl font-semibold text-white mb-5">
            Let's Connect
          </h2>
          <p className="max-w-sm mt-4 mb-4 text-gray-300">
            Whether you have a project in mind, a collaboration proposal, or
            just want to connect, I'd love to hear from you. Here are the ways
            you can get in touch:
          </p>
          <div className="flex items-center mt-8 space-x-2 text-dark-600">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              aria-hidden="true"
              className="w-4 h-4 text-white"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M9 6.75V15m6-6v8.25m.503 3.498l4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 00-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0z"
              ></path>
            </svg>
            <span className="text-gray-300">
              Calumpit, Bulacan. Philippines.
            </span>
          </div>
          <div className="flex items-center mt-2 space-x-2 text-dark-600">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              aria-hidden="true"
              className="w-4 h-4 text-white"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
              ></path>
            </svg>
            <a
              className="text-gray-300 hover:text-[#09bef0]"
              href="mailto:richard.tambong04@gmail.com"
            >
              richard.tambong04@gmail.com
            </a>
          </div>

          <div className="flex items-center mt-2 space-x-2 text-dark-600">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              aria-hidden="true"
              className="w-4 h-4 text-white"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
              ></path>
            </svg>
            
            <a
              className="text-gray-300 hover:text-[#09bef0]"
              href="tel:+639686017515"
            >
              +63 968 601 7515
            </a>
          </div>
          <div className="flex items-center">
            <span className="text-2xl font-semibold my-5 text-white">
              Social Media
            </span>
          </div>
          <div className="flex items-center xs:pb-5">
          <motion.div
              whileHover={{ scale: 1.3, rotate: 20 }}
              whileTap={{
                scale: 1,
                rotate: 0,
                borderRadius: "100%",
              }}
            >
              <Link to="https://www.facebook.com/ov3rchard" target="_blank">
                <FontAwesomeIcon
                  className="text-gray-300 hover:text-[#09bef0] text-2xl mr-2"
                  icon={faFacebookF}
                />
              </Link>
            </motion.div>

            <motion.div
              whileHover={{ scale: 1.3, rotate: 20 }}
              whileTap={{
                scale: 1,
                rotate: 0,
                borderRadius: "100%",
              }}
            >
              <Link to="https://m.me/ov3rchard" target="_blank">
                <FontAwesomeIcon
                  className="text-gray-300 hover:text-[#09bef0] text-2xl mx-2"
                  icon={faFacebookMessenger}
                />
              </Link>
            </motion.div>

            <motion.div
              whileHover={{ scale: 1.3, rotate: 20 }}
              whileTap={{
                scale: 1,
                rotate: 0,
                borderRadius: "100%",
              }}
            >
              <Link to="https://www.instagram.com/ov3rchard" target="_blank">
                <FontAwesomeIcon
                  className="text-gray-300 hover:text-[#09bef0] text-2xl mx-2"
                  icon={faInstagram}
                />
              </Link>
            </motion.div>

            <motion.div
              whileHover={{ scale: 1.3, rotate: 20 }}
              whileTap={{
                scale: 1,
                rotate: 0,
                borderRadius: "100%",
              }}
            >
              <Link to="https://www.linkedin.com/in/ov3rchard" target="_blank">
                <FontAwesomeIcon
                  className="text-gray-300 hover:text-[#09bef0] text-2xl mx-2"
                  icon={faLinkedin}
                />
              </Link>
            </motion.div>

            <motion.div
              whileHover={{ scale: 1.3, rotate: 20 }}
              whileTap={{
                scale: 1,
                rotate: 0,
                borderRadius: "100%",
              }}
            >
              <Link to="https://www.github.com/chardtmbng02" target="_blank">
                <FontAwesomeIcon
                  className="text-gray-300 hover:text-[#09bef0] text-2xl ml-2"
                  icon={faGithub}
                />
              </Link>
            </motion.div>
          </div>
        </div>
        <div>
          <div className="md:hidden xs:block xs:py-5">
            <span className="text-2xl font-semibold text-white">
              Get Started
            </span>
          </div>

          <form>
            <input type="checkbox" className="hidden" name="botcheck" />
            <div className="mb-5">
              <input
                type="text"
                placeholder="Full Name"
                autocomplete="false"
                className="w-full px-4 py-3 border-2 placeholder:text-neutral-800 rounded-md outline-none focus:ring-4 border-neutral-300 focus:border-neutral-600 ring-neutral-100"
                name="name"
              />
            </div>
            <div className="mb-5">
              <label for="email_address" className="sr-only">
                Email Address
              </label>
              <input
                id="email_address"
                type="email"
                placeholder="Email Address"
                autocomplete="false"
                className="w-full px-4 py-3 border-2 placeholder:text-neutral-800 rounded-md outline-none focus:ring-4  border-neutral-300 focus:border-neutral-600 ring-neutral-100 "
                name="email"
              />
            </div>
            <div className="mb-3">
              <textarea
                placeholder="Your Message"
                className="w-full px-4 py-3 border-2 placeholder:text-neutral-800 rounded-md outline-none  h-36 focus:ring-4  border-neutral-300 focus:border-neutral-600 ring-neutral-100"
                name="message"
              ></textarea>
            </div>
            <button
              type="submit"
              className="w-full py-4 font-semibold text-white  hover:text-black transition-colors rounded-md bg-emerald-800 hover:bg-emerald-700  outline outline-white focus:ring-offset-2 focus:ring focus:ring-neutral-200 px-7 "
            >
              Send Message
            </button>
          </form>
        </div>
      </div>
    </>
  );
};
